export const MetaTypes = [
  { id: 0, type: "name" },
  { id: 1, type: "property" },
];

export const MetaContentTypes = [
  { id: 0, type: "keywords" },
  { id: 1, type: "description" },
];
